import { Component, Input } from '@angular/core';
import { WaiterTable } from '../../../interfaces/table';
import { MatDialog } from '@angular/material/dialog';
import { ElementTablesModalComponent } from '../../../components/modals/element-tables-list/element-tables-modal.component';

@Component({
  selector: 'app-waiter-tables',
  templateUrl: './waiter-tables.component.html',
  styleUrls: ['./waiter-tables.component.scss']
})
export class WaiterTablesComponent {

  @Input() tables: WaiterTable[] = [];
  @Input() waiterName = '';
  constructor(
    private dialog: MatDialog
  ) {}

  showMore(): void {
    this.dialog.open(ElementTablesModalComponent, {data: {type: 'waiter', tables: this.tables, waiterName: this.waiterName}});
  }
}
